import React from 'react'
import './service.css'
import code from '../Assects/code.png'
import mobile from '../Assects/mobile.jpg'
import app from '../Assects/app.png'
import desktop from '../Assects/desktop.png'
import diamond from '../Assects/diamond.png'
import ui from '../Assects/ui-ux.png'

const Service = () => {
  return (
    <div className="service-section">
    <div className="service">
      <div className="service-box">
        <img src={app} alt="img" className='app-png' />
        <h1 className='app-head' id='fullStack'>Full Stack Development</h1>
        <p className="app-para">
        Building intuitive and high-performance websites tailored to user needs. Specializing in full-stack (MERN) development, combining sleek UI/UX design with robust backend solutions for an enhanced user experience.
        </p>
      </div>
      <div className="service-box">
        <img src={code} alt="img" className='code-png'/>
        <h1 className='web-head'>Web Development</h1>
        <p className='code-para'>Crafting responsive, user-friendly websites with a focus on modern design and seamless functionality. Specializing in HTML, CSS, JavaScript, React.js, and Bootstrap to bring dynamic and visually appealing web experiences to life</p>
      </div>
      <div className="service-box">
        <img src={desktop} alt="img" className='desktop-png'/>
        <h1>Web design</h1>
        <p className="desktop-para">
        Creating visually stunning and user-centered web designs that balance aesthetics with functionality. Focused on delivering unique, modern layouts that enhance brand identity and user engagement
        </p>
      </div>
      <div className="service-box">
        <img src={mobile} alt="img" className='mobile-png' />
        <h1>Fully Responsive</h1>
        <p className="mobile-para">
        Delivering fully responsive websites that adapt seamlessly to any device, ensuring an optimal user experience across desktops, tablets, and smartphones with clean, efficient code
        </p>
      </div>
      <div className="service-box">
        <img src={diamond} alt="img" className='creative-png' />
        <h1>Creative Design</h1>
        <p className="creative-para">
        Bringing ideas to life with innovative and eye-catching designs. Specializing in crafting unique visuals that elevate brand identity and leave a lasting impression
        </p>
      </div>
      <div className="service-box">
        <img src={ui} alt="img" className='ui-png'/>
        <h1>UI/UX</h1>
        <p className="ui-para">
        Designing intuitive and engaging user interfaces with a focus on seamless user experiences. Prioritizing usability, aesthetics, and functionality to create interfaces that delight and perform
        </p>
      </div>
    </div>
    </div>
  )
}

export default Service
